import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Profil from "./pages/Profil";
import Portfolio from "./pages/Portfolio";
import Order from './pages/OrderAProject';
import Paid from './pages/PaidCourses';
import Register from './pages/Register';
import Navbar from './Navbar';
// import Navbar from './pages/StartAProject';
import Project from './pages/StartAProject'; 
import Payment from './pages/Payment'; 
import Setting from './pages/Setting'; 

function App() {
  return (
    <BrowserRouter>

      <>
        <Navbar />
        <section>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/paid" element={<Paid />} />
            <Route path="/order" element={<Order />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/profil" element={<Profil />} />
            <Route path="/register" element={<Register />} />
            <Route path="/project" element={<Project />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/setting" element={<Setting />} />
          </Routes>
        </section>
      </>
    </BrowserRouter>


  );
}

export default App;